import { render, staticRenderFns } from "./ProductOutstanding.vue?vue&type=template&id=94fa2fa0"
import script from "./ProductOutstanding.vue?vue&type=script&lang=js"
export * from "./ProductOutstanding.vue?vue&type=script&lang=js"
import style0 from "./ProductOutstanding.vue?vue&type=style&index=0&id=94fa2fa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports